import styled from "styled-components";

export const Background = styled.div`
    position: relative;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const TitleActors = styled.div`
    display: flex;
    align-items: center;
    color: #111;
    padding: 1rem;
    font-size: 1.2rem;
`;
